import { createSelector } from 'reselect';
import { selectDocumentErrorCount } from 'state/document/selector';
import { selectIsFormDataPendingValue } from 'state/formData/formData.selectors';

export const selectDocumentErrorCountWhenReady = createSelector(
  [selectDocumentErrorCount, selectIsFormDataPendingValue],
  (errorCount, isPending) => {
    return isPending ? 0 : errorCount;
  },
);
